<template>
    <div>
        <div class="row">
            <div class="col-lg-4 d-none d-lg-block" style="height: 85vh;"></div>
            <div class="col-lg-4 d-flex align-items-center mt-5 mt-lg-0">
                <transition name="fade"
                            mode="out-in">
                    <div class="card login w-100 p-5 animated fadeInRight" id="step1" v-if="!step1Status" key="step1">
                        <h2 class="text-center mb-4">ورود به حساب کاربری</h2>
                        <h6 class="text-center mb-3 text-wrap">لطفا شماره تلفن همراه خود را وارد نمایید و یا جهت ورود به
                            عنوان میهمان و تست نرم افزار حسابداری فروشگاهی، شماره(09123456789) را وارد کنید.</h6>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-mobile-phone"></i></span>
                            </div>
                            <input type="number" class="form-control" placeholder="شماره تلفن" v-model="step1.mobileNo"
                                   @keydown.enter="loginStep1" :disabled="loading"/>
                        </div>
                        <button class="btn btn-primary mt-3" @click="loginStep1" :disabled="loading">
                            <span v-if="!loading">ارسال</span>
                            <div v-if="loading" class="cssload-container">
                                <div class="cssload-speeding-wheel"></div>
                            </div>
                        </button>
                    </div>
                    <div class="card login w-100 p-5" id="step2" v-if="step1Status" key="step2">
                        <h2 class="text-center mb-4">ورود به حساب کاربری</h2>
                        <h6 class="text-center mb-3 text-wrap">کد ارسال شده به شماره {{step1.mobileNo}} را وارد نمایید.
                            در صورتی که به عنوان میهمان وارد شده اید دکمه ثبت را بزنید</h6>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-keyboard-o"></i></span>
                            </div>
                            <input type="number" class="form-control" placeholder="کد" v-model="step2.token"
                                   @keydown.enter="loginStep2" id="codeInput"/>
                        </div>
                        <button class="btn btn-success mt-3" @click="loginStep2">ثبت</button>
                        <button class="btn btn-link text-center mt-5 resend" @click="loginStep1" :disabled="loading">
                            ارسال مجدد
                        </button>
                        <small class="btn btn-link text-center mt-3 resend" @click="loginMobile" :disabled="loading">
                            اصلاح شماره تلفن
                        </small>
                    </div>
                </transition>

            </div>
            <div class="col-lg-4">

            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import * as $ from "jquery";
    import axios from "axios";
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import Constants from "../Constants";

    export default {
        name: 'login',
        data() {
            return {
                step1: {
                    mobileNo: "",
                    identifier: "web.app",
                    packageName: "ir.badian.store",
                },
                step2: {
                    mobileNo: "",
                    identifier: "web.app",
                    packageName: "ir.badian.store",
                    token: "",
                    presenterCode: "",
                    pusheId: ""
                },
                step1Status: false,

                loading: false
            }
        },
        mounted() {
            if (this.$route.query.unauthorized) {
                this.$noty.error('لطفا ابتدا وارد حساب کاربری خود شوید!');
            }
            axios.defaults.baseURL = Constants.AUTH_API_BASE_URL;
            localStorage.removeItem("phoneNumber");
            /*localStorage.removeItem("token_mobile");*/
            localStorage.removeItem("isRegistered");
        },
        methods: {
            loginStep1() {
                /*new BaseService('sms', '/sendsmsconfirm').create(this.step1).then(response => {
                    $("#step1").addClass("animated fadeOutLeft");
                    setTimeout(() => {
                        this.step1Status = true;
                    }, 1000);
                    this.$noty.success(response.value);
                }).catch(error => {

                })*/
                if (!this.loading) {
                    axios.post('Sms/SendSmsConfirm', this.step1).then(response => {
                        //$("#step1").addClass("animated fadeOutLeft");
                        this.step2.mobileNo = this.step1.mobileNo;
                        this.$noty.success('ارسال با موفقیت انجام شد!');
                        this.step1Status = true;
                        this.loading = false;
                        setTimeout(() => {
                            $("#codeInput").focus();
                        }, 800)
                    }).catch(error => {
                        this.loading = false;
                        Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                    });
                }
                this.loading = true;
            },
            loginStep2() {
                if (!this.loading) {
                    axios.post('Sms/SmsConfirm', this.step2).then(response => {
                        this.loading = false;
                        localStorage.setItem("phoneNumber", this.step2.mobileNo);
                        localStorage.setItem("token_mobile", response.data.jwtToken);
                        EventBus.$emit('logOut', false);
                        if (response.data.isCompletedInfo) {
                            localStorage.setItem("isRegistered", "true");
                            axios.defaults.headers.common['authorization'] = 'Bearer ' + response.data.jwtToken;
                            localStorage.setItem("userId", response.data.uid);
                            this.$noty.info('لطفا فروشگاه خود را انتخاب نمایید');
                            this.$router.push({name: 'select-store'});
                        } else {
                            localStorage.setItem("isRegistered", "false");
                            this.$noty.info('لطفا اطلاعات کاربری خود را تکمیل نمایید');
                            localStorage.setItem("userId", response.data.uid);
                            this.$router.push({name: 'profile'});
                        }

                    }).catch(error => {
                        this.loading = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            loginMobile() {
                this.step1Status = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .resend:hover {
        text-decoration: none;
        background-color: #eee;
        border-radius: 4px;
    }
</style>